



































import { defineComponent, PropType, ref } from "@vue/composition-api";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import { getElement } from "@/lib/elementHelpers";
import { $t } from "@/lib/i18nHelpers";
import { AttachmentFile } from "@/types";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseSendMessage",
  components: { BaseInputTextarea, BaseSpinner },
  props: {
    keepFocus: { type: Boolean, default: false },
    sending: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    files: { type: Array as PropType<AttachmentFile[]> | null, default: null },
    placeholder: { type: String as PropType<TranslateResult | string>, default: $t("Message") },
    priceAmount: { type: String },
    appendIcon: { type: String, default: "sci-send" },
    secondAppendIcon: { type: String },
    prependIcon: { type: String },
    prependIconColor: { type: String },
    allowSend: {
      type: Function as PropType<(v: string) => boolean>,
      default: (value: string) => {
        return value.length > 0;
      },
    },
  },
  setup(props, { emit }) {
    const baseInput = ref<Vue | undefined>();
    const value = ref("");

    const clearInput = () => {
      value.value = "";
      emit("input", value.value);
    };

    const inputMessage = (v: string) => {
      value.value = v;
      emit("input", value.value);
    };

    const sendMessage = useAuthorisedOnly(() => {
      if (props.sending || !props.allowSend(value.value.trim()) || (!value.value && !props.files)) {
        return;
      }
      emit("send", value.value.trim(), clearInput);
      if (props.keepFocus) {
        try {
          getElement<HTMLInputElement>(baseInput.value?.$refs.textareaElement).focus();
        } catch (e) {}
      }
    });
    return {
      value,
      baseInput,
      sendMessage,
      inputMessage,
    };
  },
});
